import { reactive } from 'vue'
import actions from '@/store/upgrade/actions'
import state from '@/store/upgrade/state'
import getters from '@/store/upgrade/getters'

export const upgradeModule = {
    state: reactive(state),
    actions,
    getters,
}
